<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/login">登录</el-breadcrumb-item>
        <el-breadcrumb-item>《用户服务协议和隐私政策》</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card class="box-card">
        <div slot="header" class="header">
          <span>《用户服务协议和隐私政策》</span>
        </div>
        <div v-html="body"></div>
      </el-card>
    </div>
  </el-main>
</template>

<script>
import {request} from '@/utils/request'

export default {
  name: "Agreement",
  head: {
    title: "用户服务协议和隐私政策"
  },
  data() {
    return {
      body: ''
    }
  },
  created() {
    this.getAgreement()
  },
  methods: {
    async getAgreement() {
      try {
        let response = await request('/setting/agreement', {
          method: 'GET'
        })
        this.body = response.data.agreement
      } catch (e) {

      }
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
}
</style>